<div class="tile-type-mat-icon-wrapper">
   <mat-icon>apps</mat-icon>
</div>
